/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PackageResponse } from '../models/package-response';

/**
 * Ui Artifact Hub Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiArtifactHubControllerService extends __BaseService {
  static readonly getHelmValuesUsingGETPath =
    '/cc-ui/v1/artifactHub/packages/{packageId}/values';
  static readonly searchPackagesUsingGETPath =
    '/cc-ui/v1/artifactHub/search-packages';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getHelmValues
   * @param params The `UiArtifactHubControllerService.GetHelmValuesUsingGETParams` containing the following parameters:
   *
   * - `version`: version
   *
   * - `packageId`: packageId
   *
   * @return OK
   */
  getHelmValuesUsingGETResponse(
    params: UiArtifactHubControllerService.GetHelmValuesUsingGETParams,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.version != null)
      __params = __params.set('version', params.version.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/artifactHub/packages/${encodeURIComponent(
          String(params.packageId),
        )}/values`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * getHelmValues
   * @param params The `UiArtifactHubControllerService.GetHelmValuesUsingGETParams` containing the following parameters:
   *
   * - `version`: version
   *
   * - `packageId`: packageId
   *
   * @return OK
   */
  getHelmValuesUsingGET(
    params: UiArtifactHubControllerService.GetHelmValuesUsingGETParams,
  ): __Observable<{}> {
    return this.getHelmValuesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as {}),
    );
  }

  /**
   * searchPackages
   * @param params The `UiArtifactHubControllerService.SearchPackagesUsingGETParams` containing the following parameters:
   *
   * - `verified`: verified
   *
   * - `tsQueryWeb`: tsQueryWeb
   *
   * - `sort`: sort
   *
   * - `offset`: offset
   *
   * - `limit`: limit
   *
   * - `facets`: facets
   *
   * - `category`: category
   *
   * @return OK
   */
  searchPackagesUsingGETResponse(
    params: UiArtifactHubControllerService.SearchPackagesUsingGETParams,
  ): __Observable<__StrictHttpResponse<PackageResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.verified != null)
      __params = __params.set('verified', params.verified.toString());
    if (params.tsQueryWeb != null)
      __params = __params.set('tsQueryWeb', params.tsQueryWeb.toString());
    if (params.sort != null)
      __params = __params.set('sort', params.sort.toString());
    if (params.offset != null)
      __params = __params.set('offset', params.offset.toString());
    if (params.limit != null)
      __params = __params.set('limit', params.limit.toString());
    if (params.facets != null)
      __params = __params.set('facets', params.facets.toString());
    if (params.category != null)
      __params = __params.set('category', params.category.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/artifactHub/search-packages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PackageResponse>;
      }),
    );
  }
  /**
   * searchPackages
   * @param params The `UiArtifactHubControllerService.SearchPackagesUsingGETParams` containing the following parameters:
   *
   * - `verified`: verified
   *
   * - `tsQueryWeb`: tsQueryWeb
   *
   * - `sort`: sort
   *
   * - `offset`: offset
   *
   * - `limit`: limit
   *
   * - `facets`: facets
   *
   * - `category`: category
   *
   * @return OK
   */
  searchPackagesUsingGET(
    params: UiArtifactHubControllerService.SearchPackagesUsingGETParams,
  ): __Observable<PackageResponse> {
    return this.searchPackagesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as PackageResponse),
    );
  }
}

module UiArtifactHubControllerService {
  /**
   * Parameters for getHelmValuesUsingGET
   */
  export interface GetHelmValuesUsingGETParams {
    /**
     * version
     */
    version: string;

    /**
     * packageId
     */
    packageId: string;
  }

  /**
   * Parameters for searchPackagesUsingGET
   */
  export interface SearchPackagesUsingGETParams {
    /**
     * verified
     */
    verified?: boolean;

    /**
     * tsQueryWeb
     */
    tsQueryWeb?: string;

    /**
     * sort
     */
    sort?: string;

    /**
     * offset
     */
    offset?: number;

    /**
     * limit
     */
    limit?: number;

    /**
     * facets
     */
    facets?: boolean;

    /**
     * category
     */
    category?: number;
  }
}

export { UiArtifactHubControllerService };
